import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { getToken, getRank } from './Common';
const PublicRoute = ({ component: Component, redirectPath = "/Admin_dashboard", ...rest }) => {
  const token = getToken();

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          // If authenticated, redirect to the dashboard
          <Redirect to={redirectPath} />
        ) : (
          // If not authenticated, render the requested public component (e.g., Login)
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;